import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import { withCookies } from 'react-cookie';
import { ChatContext } from '@/ChatProvider';
import * as pageSourceCode from '@scripts/PageSourceCode';
import ListRequestItems from './ListRequestItems'
import FilterRequest from './FilterRequest'
import styles from '@styles/approvalCentral.module.css'

const useStyles = theme => ({
    toolBar: {
        alignSelf: 'flex-end'
    }
});

class ListRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            authenticated: false,
            expanded: false,
            data: null,
            filter: {}
        }
    }

    handleFilter = (filters) => {
        this.setState({
            filter: {
                typeRequest: filters[0],
                status: filters[1]
            }
        });
    }

    render() {
        return (
            <div className={styles.rootRequest}>
                <FilterRequest pageSource={pageSourceCode.APPROVAL_CENTRAL} handleFilter={this.handleFilter} />
                <ListRequestItems filter={this.state.filter} />
            </div>
        );
    }
}

ListRequest.contextType = ChatContext;
export default withNamespaces(['approvalCentral'], { wait: true })(withStyles(useStyles)(withCookies(ListRequest)));